import { useCallback } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Form } from "@/components/controls";
import {
  TaxInformationForm,
  useTaxInformationForm,
} from "@/components/profile-forms/TaxInformationForm";
import type { IInspectorW9Form } from "@/types/users-inspectors";
import { Button, Drawer } from "@/ui-kit";

type IProps = {
  userId: number;
  w9form: IInspectorW9Form;
  onSave: (v: IInspectorW9Form) => void;
  onDismiss: () => void;
};

const EditModal = ({ userId, w9form, onSave, onDismiss }: IProps) => {
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (response: IInspectorW9Form) => {
      onSave(response);
      onDismiss();
    },
    [onSave, onDismiss],
  );

  const { form, onSubmit, loading, disabled, setDisabled } =
    useTaxInformationForm({
      userId,
      w9Form: w9form,
      onSuccess: handleSuccess,
    });

  return (
    <FormProvider {...form}>
      <Drawer
        className="settings__user-modal"
        open={true}
        onOpenChange={onDismiss}
        closeOnOutsidePress={false}
      >
        <Drawer.Header title={t("label.tax_information")} />
        <Drawer.Body>
          <Form>
            <TaxInformationForm setDisabled={setDisabled} />
          </Form>
        </Drawer.Body>
        <Drawer.Footer>
          <Button onClick={onDismiss} variant="ghost" color="neutral">
            {t("action.cancel")}
          </Button>
          <Button onClick={onSubmit} loading={loading} disabled={disabled}>
            {t("action.save")}
          </Button>
        </Drawer.Footer>
      </Drawer>
    </FormProvider>
  );
};

export default EditModal;
